import {Component, EventEmitter, inject, Input, OnInit, Output} from '@angular/core';
import {TableColumn} from '../../../interfaces/table.interface';
import {PageableParam, SearchCombinationTypeEnum, SearchFieldsDtoInput} from '../../../interfaces/data.interfaces';
import {PageEvent} from '@angular/material/paginator';
import {DialogService} from '../../../../services/dialog.service';
import {TableColumnSelectionComponent} from '../table-column-selection/table-column-selection.component';
import {TableAdvanceSearchComponent} from '../table-advance-search/table-advance-search.component';

@Component({
    selector: 'app-pagination-buttons',
    templateUrl: './pagination-buttons.component.html',
    styleUrls: ['./pagination-buttons.component.scss'],
    standalone: false
})
export class PaginationButtonsComponent implements OnInit {

  @Input() currentPage = 0;
  @Input() totalPage: number;
  @Input() totalElement = 0;
  @Input() pagination: any[];
  @Input() pageSizeOptions = [10, 50, 100, 250];
  @Output() clickedPage: EventEmitter<any> = new EventEmitter();
  @Output() selectedPageSize: EventEmitter<number> = new EventEmitter();

  @Input() pageSize = 10;

  @Input() hidePageSize = true;
  @Input() showPageSizeOptions = true;
  @Input() showFirstLastButtons = true;
  @Input() tableColumns: TableColumn[];
  @Input() extraTableColumns: TableColumn[];

  @Output() onTableColumnSelection = new EventEmitter<TableColumn[]>();
  @Output() onTableAdvanceSearch = new EventEmitter<PageableParam>();
  @Output() onCopyClicked = new EventEmitter<boolean>();

  @Input() searchFields: SearchFieldsDtoInput[];
  @Input() cacheAdvanceSearchFields: SearchFieldsDtoInput[];
  @Input() cacheSearchCombinationType: SearchCombinationTypeEnum;

  pageEvent: PageEvent;

  dialogService = inject(DialogService);

  ngOnInit(): void {
  }

  handlePageEvent(e: PageEvent) {
    this.pageEvent = e;
    this.totalElement = e.length;
    this.pageSize = e.pageSize;
    this.currentPage = e.pageIndex;

    this.clickedPage.emit(this.currentPage);
    this.selectedPageSize.emit(this.pageSize);
  }

  setPage(page: number) {
    this.clickedPage.emit(page);
  }

  setPageSize(size: number) {
    this.pageSize = size;
    this.selectedPageSize.emit(size);
  }

  openColumnSection() {
    const data = {
      tableColumns: this.tableColumns,
      extraTableColumns: this.extraTableColumns
    };

    this.dialogService.open({ data, component: TableColumnSelectionComponent, width: '20%'}).then( value => {
      if (value?.length > 0){
        this.onTableColumnSelection.emit(value);
      }
    });
  }

  advanceSearch() {
    const data = {
      searchFields: this.searchFields,
      cacheSearchCombinationType: this.cacheSearchCombinationType,
      cacheAdvanceSearchFields: this.cacheAdvanceSearchFields
    };

    this.dialogService.open({ data, component: TableAdvanceSearchComponent, width: '60%'}).then( (value: PageableParam) => {
      if (value){
        this.cacheSearchCombinationType = value?.searchCombinationType;
        this.cacheAdvanceSearchFields = value?.searchFields;
        this.onTableAdvanceSearch.emit(value);
      }
    });
  }

  copyTable() {
    this.onCopyClicked.emit(true);
  }
}
